import React from 'react'

import Icon from 'Pods/Shared/Icon/Icon'

function NoSearchResults() {
  return (
    <div>
      <Icon type={['far', 'search']} color="grey" size="5x" />
      <p className="empty-content__text">
        You have no products for this search query.
        <br />
        Refine your search and try again.
      </p>
    </div>
  )
}

export default NoSearchResults
